import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-help-message',
  styles: [
    `
      @import 'partials/variables';

      span {
        font-weight: normal;
        line-height: 1.2rem;
        color: var(--light-text);
      }
      ::ng-deep {
        .p-tag.p-tag-info {
          background-color: var(--info);
        }
      }
    `,
  ],
  template: `
    <section class="mt-2 help-component" [ngClass]="class" *ngIf="message">
      <p-tag
        [severity]="severity"
        [value]="label | translate"
        [icon]="'pi ' + icon"
      ></p-tag>
      <span class="ml-1"> {{ message }}</span>
    </section>
  `,
})
export class HelpMessageComponent {
  /**
   * @description
   * You can call this component anywhere in the application
   * to add some help text or additional explanation.
   */

  /**
   * * Inputs
   * @message The message to be displayed
   * @label Text within the badge component
   * @icon The primeng icon that will be displayed
   * @severity Help message type
   * @class Css classes for main component container
   */
  @Input() message: string;
  @Input() label = 'Pomoć';
  @Input() icon = 'pi-info';
  @Input() severity = 'info';
  @Input() class = '';
}
